import { i18n } from '@/locales';
const lc = 'views.user_management.';
const userListTableHeader = [
    {
        title: i18n.t(`${lc}status`),
        align: 'center',
        sortable: true,
        value: 'useYn',
        width: 74,
    },
    {
        title: i18n.t(`${lc}user_id`),
        align: 'center',
        sortable: true,
        value: 'userId',
        width: 200,
    },
    {
        title: i18n.t(`${lc}hub_name`),
        align: 'center',
        sortable: false,
        value: 'hubName',
        width: 200,
    },
    {
        title: i18n.t(`${lc}user_level`),
        align: 'center',
        sortable: true,
        value: 'level',
        width: 140,
    },
    {
        title: i18n.t(`${lc}user_name`),
        align: 'center',
        sortable: true,
        value: 'name',
        width: 200,
    },
    {
        title: i18n.t(`${lc}admin_phone_number`),
        align: 'center',
        sortable: false,
        value: 'phone',
        width: 180,
    },
    {
        title: i18n.t(`${lc}registration_date`),
        align: 'center',
        sortable: false,
        value: 'registrationDate',
        width: 120,
    },
    {
        title: i18n.t(`${lc}resignation_at`),
        align: 'center',
        sortable: false,
        value: 'resignationAt',
        width: 120,
    },
    {
        title: i18n.t(`${lc}memo`),
        align: 'center',
        sortable: false,
        value: 'memo',
        width: 400,
    },
    {
        title: i18n.t(`${lc}permission`),
        align: 'center',
        value: 'permission',
        width: 150,
    },
    {
        title: '',
        align: 'center',
        value: 'dummy',
    },
];
export default userListTableHeader;
